<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-14 09:50:24
-->
<template>
  <div>
    <div class="maintitle">优秀统计</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="20">
      <el-select v-model='slctYear' class='margin-right' style='width:120px' size='mini' placeholder="请选择年份">
        <el-option v-for="(item) in yearlist" :key='item.id' :value='item.id' :label='item.title'></el-option>
      </el-select>
      <el-select v-model='slctMonth' clearable class='margin-right' style='width:120px' size='mini' placeholder="请选择月份">
        <el-option v-for="(item) in monthlist" :key='item.id' :value='item.id' :label='item.title'></el-option>
      </el-select>
      <!-- <el-date-picker v-model="month" type="month" placeholder="选择考核月份" size='mini'>
      </el-date-picker> -->
      <el-select v-model='excellent' size='mini' class="margin-left">
        <el-option :value="0" label='全部'></el-option>
        <el-option v-for="(item,index) in excellentTypeList" :key='index' :index='index' :value='item.excellent_id' :label='item.excellent_title'></el-option>
      </el-select>
      <el-select v-model='type' size='mini' class="margin-left" @change="list=[]">
        <el-option :value='1' label='员工'></el-option>
        <el-option :value='2' label='部门'></el-option>
      </el-select>
      <el-button @click="getlist" size='mini' class="margin-left">查询</el-button>
      <el-button @click="outList" size='mini' class="margin-left">导出</el-button>
    </el-row>
    <div class="excellentDiv">
      <li v-for='(item,index) in list' :index='index' :key='index'>
        <span v-if='type==1'>{{item.department}}-</span><span>{{item.name}}</span>
        <span>({{item.excellent_text}})</span>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      // month:'',
      excellent:0,
      type:1,
      slctYear:'',
      slctMonth:''
    };
  },
  computed: {
    yearlist(){
      let temp = [];
      for(let i=2022;i<2032;i++){
        temp.push({
          id:i,
          title:i+'年'
        })
      }
      return temp;
    },
    monthlist(){
      let temp = [];
      for(let i=1;i<=12;i++){
        temp.push({
          id:i,
          title:i+'月'
        })
      }
      return temp;
    }
  },
  methods: {
    getlist() {
      if(this.slctYear==''){
        this.$message({
          type:'error',
          message:'请选择年份'
        })
        return;
      }
      this.$axios({
        url: this.HOST + "/kaohe/viewass/getexcellentlist",
        method: "post",
        data: {
          // month:this.month,
          year:this.slctYear,
          month:this.slctMonth,
          excellent:this.excellent,
          type:this.type,
        },
      }).then((res) => {
        this.list = res.data.list;
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    outList(){
      // let date;
      // if(this.month){
      //   date = new Date(this.month);
      // }else{
      //   date = new Date();
      //   date.setDate(date.getDate()-10);
      // }
      // let month = date.getFullYear()+'-'+(date.getMonth()+1);
      if(this.slctYear==''){
        this.$message({
          type:'error',
          message:'请选择年份'
        })
        return;
      }
      this.$axios({
        url: this.HOST + "/kaohe/viewass/outExcellentList",
        method: "post",
        data: {
          year:this.slctYear,
          month:this.slctMonth,
          excellent:this.excellent,
          type:this.type,
        },
        responseType: "blob"
      }).then(res => {
        let blob = new Blob([res.data]);
        let fileName = (this.type==1?'员工':'部门')+"考核列表.csv";
        if ("download" in document.createElement("a")) {
          // 不是IE浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(url); // 释放掉blob对象
        } else {
          // IE 10+
          window.navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
  created: function () {
    // this.getlist();
  },
};
</script>
<style scoped>
.excellentDiv{
  width:100%;
  padding:20px;
  display:flex;
  flex-wrap: wrap;
}
.excellentDiv > li{
  margin-right: 20px;
  padding:10px;
}
</style>